export const getFormattedCombinedGraphs = (graphData = {}) => {
  return Object.entries(graphData).map(data => {
    return {
      breakdown: data[0],
      ...data[1]
    }
  })
}
